var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutubeLtr = function SvgSocialYoutubeLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.913 24.851c-1.154-4.34-4.54-7.744-8.843-8.898C81.27 13.848 50 13.848 50 13.848s-31.27 0-39.07 2.105c-4.302 1.154-7.69 4.559-8.843 8.898C0 32.705 0 49.073 0 49.073S0 65.44 2.087 73.295c1.154 4.339 4.54 7.598 8.843 8.751C18.73 84.152 50 84.152 50 84.152s31.27 0 39.07-2.106c4.302-1.153 7.69-4.43 8.843-8.751C100 65.44 100 49.073 100 49.073s0-16.368-2.087-24.222M39.784 63.939V34.207L65.91 49.073z"
  })));
};
export default SvgSocialYoutubeLtr;